//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por adicionar Tags em Massa no banco de dados via API
export default async function removeTagsBulkService (tags) {
  try {
    await api.post("/leads/tags/remover", { tags });
    toast.success("Tags removidas em massa com sucesso");
    return true;
  } catch (error) {
    toast.error("Erro ao remover tags em massa");
    return false;
  }
}

